import { merge } from 'lodash';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as impactAssessmentProductTypes from './impactAssessmentProductTypes';

const byId = handleActions(
  {
    [impactAssessmentProductTypes.IMPACT_ASSESSMENT_PRODUCT_LIST.SUCCESS]: (state, { payload }) =>
      merge({}, state, payload.entities.impactAssessmentProducts),
  },
  {},
);

const allIds = handleActions(
  {
    [impactAssessmentProductTypes.IMPACT_ASSESSMENT_PRODUCT_LIST.SUCCESS]: (state, { payload }) => payload.result,
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
